/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";

export function SpecificationEditDialogHeader({ showTitle, id, reduxName }) {
  const [title, setTitle] = useState("");
  // Specs Redux state
  const { specificationForEdit, actionsLoading } = useSelector(
    (state) => ({
      specificationForEdit: state[reduxName].objectForEdit,
      actionsLoading: state[reduxName].actionsLoading,
    }),
    shallowEqual
  );

  useEffect(() => {
    let _title = id ? "" : "افزودن";
    if (reduxName === "floors")
      _title = id ? "" : "افزودن طبقه";
    if (reduxName === "rooms")
      _title = id ? "" : "افزودن اتاق";
    if (specificationForEdit && id) {
      if (reduxName === "floors")
        _title = "ویرایش طبقه " + specificationForEdit.title;
      if (reduxName === "rooms")
        _title = "ویرایش اتاق " + specificationForEdit.title;

    }

    setTitle(_title);
    // eslint-disable-next-line
  }, [specificationForEdit, actionsLoading]);
  return (
    <>
      {actionsLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg"> {title} {" - "} {showTitle} </Modal.Title>
      </Modal.Header>
    </>
  );
}
